import { StyleProp, StyleSheet, TextStyle } from "react-native";

export const getInputTypographyStyle = (
  style?: StyleProp<TextStyle>
): TextStyle => {
  const inputStyle = StyleSheet.flatten(style);
  const fontSize = Math.max(inputStyle?.fontSize ?? 16, 16);

  return {
    fontSize,
    ...(inputStyle?.lineHeight !== undefined
      ? { lineHeight: Math.max(inputStyle.lineHeight, fontSize) }
      : {}),
  };
};
